// Shared location data - Countries, States, Cities
// Used by ProfileForm, Profiles listing, and Directory listing

export const locationData = {
  'United States': {
    'Alabama': ['Birmingham', 'Montgomery', 'Huntsville', 'Mobile', 'Tuscaloosa'],
    'Alaska': ['Anchorage', 'Fairbanks', 'Juneau'],
    'Arizona': ['Phoenix', 'Tucson', 'Mesa', 'Scottsdale', 'Chandler', 'Tempe'],
    'Arkansas': ['Little Rock', 'Fort Smith', 'Fayetteville'],
    'California': ['Los Angeles', 'San Francisco', 'San Diego', 'San Jose', 'Sacramento', 'Fresno', 'Oakland', 'Irvine', 'Pasadena', 'Long Beach', 'Santa Monica', 'Beverly Hills', 'Anaheim', 'Riverside'],
    'Colorado': ['Denver', 'Colorado Springs', 'Aurora', 'Boulder', 'Fort Collins'],
    'Connecticut': ['Hartford', 'New Haven', 'Stamford', 'Bridgeport'],
    'Delaware': ['Wilmington', 'Dover', 'Newark'],
    'Florida': ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale', 'St. Petersburg', 'Naples', 'West Palm Beach'],
    'Georgia': ['Atlanta', 'Savannah', 'Augusta', 'Athens'],
    'Hawaii': ['Honolulu', 'Hilo', 'Kailua'],
    'Idaho': ['Boise', 'Meridian', 'Nampa'],
    'Illinois': ['Chicago', 'Aurora', 'Naperville', 'Springfield', 'Rockford'],
    'Indiana': ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend'],
    'Iowa': ['Des Moines', 'Cedar Rapids', 'Iowa City'],
    'Kansas': ['Wichita', 'Overland Park', 'Kansas City', 'Topeka'],
    'Kentucky': ['Louisville', 'Lexington', 'Bowling Green'],
    'Louisiana': ['New Orleans', 'Baton Rouge', 'Shreveport'],
    'Maine': ['Portland', 'Bangor', 'Augusta'],
    'Maryland': ['Baltimore', 'Bethesda', 'Rockville', 'Annapolis'],
    'Massachusetts': ['Boston', 'Cambridge', 'Worcester', 'Springfield'],
    'Michigan': ['Detroit', 'Grand Rapids', 'Ann Arbor', 'Lansing'],
    'Minnesota': ['Minneapolis', 'St. Paul', 'Rochester', 'Duluth'],
    'Mississippi': ['Jackson', 'Gulfport', 'Biloxi'],
    'Missouri': ['Kansas City', 'St. Louis', 'Springfield', 'Columbia'],
    'Montana': ['Billings', 'Missoula', 'Great Falls'],
    'Nebraska': ['Omaha', 'Lincoln'],
    'Nevada': ['Las Vegas', 'Reno', 'Henderson'],
    'New Hampshire': ['Manchester', 'Nashua', 'Concord'],
    'New Jersey': ['Newark', 'Jersey City', 'Trenton', 'Princeton', 'Hoboken'],
    'New Mexico': ['Albuquerque', 'Santa Fe', 'Las Cruces'],
    'New York': ['New York City', 'Buffalo', 'Rochester', 'Albany', 'Syracuse', 'Brooklyn', 'Queens', 'Manhattan'],
    'North Carolina': ['Charlotte', 'Raleigh', 'Durham', 'Greensboro', 'Asheville'],
    'North Dakota': ['Fargo', 'Bismarck', 'Grand Forks'],
    'Ohio': ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron'],
    'Oklahoma': ['Oklahoma City', 'Tulsa', 'Norman'],
    'Oregon': ['Portland', 'Salem', 'Eugene', 'Bend'],
    'Pennsylvania': ['Philadelphia', 'Pittsburgh', 'Harrisburg', 'Allentown'],
    'Rhode Island': ['Providence', 'Warwick', 'Newport'],
    'South Carolina': ['Charleston', 'Columbia', 'Greenville', 'Myrtle Beach'],
    'South Dakota': ['Sioux Falls', 'Rapid City'],
    'Tennessee': ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga'],
    'Texas': ['Houston', 'Dallas', 'Austin', 'San Antonio', 'Fort Worth', 'El Paso', 'Plano', 'Frisco'],
    'Utah': ['Salt Lake City', 'Provo', 'Park City'],
    'Vermont': ['Burlington', 'Montpelier'],
    'Virginia': ['Virginia Beach', 'Richmond', 'Arlington', 'Alexandria', 'Norfolk'],
    'Washington': ['Seattle', 'Tacoma', 'Spokane', 'Bellevue', 'Olympia'],
    'West Virginia': ['Charleston', 'Huntington', 'Morgantown'],
    'Wisconsin': ['Milwaukee', 'Madison', 'Green Bay'],
    'Wyoming': ['Cheyenne', 'Casper', 'Jackson'],
    'Washington DC': ['Washington']
  },
  'Canada': {
    'Alberta': ['Calgary', 'Edmonton', 'Red Deer', 'Lethbridge'],
    'British Columbia': ['Vancouver', 'Victoria', 'Surrey', 'Burnaby', 'Kelowna'],
    'Manitoba': ['Winnipeg', 'Brandon'],
    'New Brunswick': ['Fredericton', 'Saint John', 'Moncton'],
    'Newfoundland and Labrador': ['St. John\'s', 'Corner Brook'],
    'Nova Scotia': ['Halifax', 'Sydney', 'Dartmouth'],
    'Ontario': ['Toronto', 'Ottawa', 'Mississauga', 'Hamilton', 'London', 'Brampton', 'Markham'],
    'Prince Edward Island': ['Charlottetown'],
    'Quebec': ['Montreal', 'Quebec City', 'Laval', 'Gatineau'],
    'Saskatchewan': ['Saskatoon', 'Regina']
  },
  'United Kingdom': {
    'England': ['London', 'Manchester', 'Birmingham', 'Liverpool', 'Leeds', 'Bristol', 'Oxford', 'Cambridge', 'Brighton', 'Bath'],
    'Scotland': ['Edinburgh', 'Glasgow', 'Aberdeen', 'Dundee'],
    'Wales': ['Cardiff', 'Swansea', 'Newport'],
    'Northern Ireland': ['Belfast', 'Derry', 'Lisburn']
  },
  'Australia': {
    'New South Wales': ['Sydney', 'Newcastle', 'Wollongong'],
    'Victoria': ['Melbourne', 'Geelong', 'Ballarat'],
    'Queensland': ['Brisbane', 'Gold Coast', 'Cairns', 'Townsville'],
    'Western Australia': ['Perth', 'Fremantle'],
    'South Australia': ['Adelaide'],
    'Tasmania': ['Hobart', 'Launceston'],
    'Australian Capital Territory': ['Canberra'],
    'Northern Territory': ['Darwin', 'Alice Springs']
  },
  'China': {
    '北京': ['北京市'],
    '上海': ['上海市'],
    '广东': ['广州', '深圳', '东莞', '佛山', '珠海', '中山'],
    '浙江': ['杭州', '宁波', '温州', '嘉兴'],
    '江苏': ['南京', '苏州', '无锡', '常州'],
    '四川': ['成都', '绵阳', '德阳'],
    '湖北': ['武汉', '宜昌'],
    '湖南': ['长沙', '株洲'],
    '福建': ['福州', '厦门', '泉州'],
    '山东': ['济南', '青岛', '烟台'],
    '天津': ['天津市'],
    '重庆': ['重庆市'],
    '辽宁': ['沈阳', '大连'],
    '陕西': ['西安'],
    '河南': ['郑州', '洛阳']
  },
  'Taiwan': {
    '台北': ['台北市', '新北市'],
    '台中': ['台中市'],
    '高雄': ['高雄市'],
    '台南': ['台南市'],
    '桃园': ['桃园市']
  },
  'Japan': {
    'Tokyo': ['Tokyo', 'Shibuya', 'Shinjuku', 'Minato'],
    'Osaka': ['Osaka', 'Sakai'],
    'Kanagawa': ['Yokohama', 'Kawasaki'],
    'Aichi': ['Nagoya'],
    'Hokkaido': ['Sapporo'],
    'Kyoto': ['Kyoto'],
    'Fukuoka': ['Fukuoka']
  },
  'South Korea': {
    'Seoul': ['Seoul'],
    'Busan': ['Busan'],
    'Gyeonggi': ['Suwon', 'Incheon', 'Seongnam'],
    'Daegu': ['Daegu']
  },
  'Singapore': {
    'Singapore': ['Singapore']
  },
  'Malaysia': {
    'Kuala Lumpur': ['Kuala Lumpur'],
    'Selangor': ['Petaling Jaya', 'Shah Alam', 'Subang Jaya'],
    'Penang': ['George Town'],
    'Johor': ['Johor Bahru']
  },
  'Germany': {
    'Bavaria': ['Munich', 'Nuremberg'],
    'Berlin': ['Berlin'],
    'Hamburg': ['Hamburg'],
    'North Rhine-Westphalia': ['Cologne', 'Düsseldorf', 'Dortmund'],
    'Hesse': ['Frankfurt', 'Wiesbaden'],
    'Baden-Württemberg': ['Stuttgart', 'Heidelberg']
  },
  'France': {
    'Île-de-France': ['Paris', 'Versailles'],
    'Provence-Alpes-Côte d\'Azur': ['Marseille', 'Nice', 'Cannes'],
    'Auvergne-Rhône-Alpes': ['Lyon', 'Grenoble'],
    'Nouvelle-Aquitaine': ['Bordeaux'],
    'Occitanie': ['Toulouse', 'Montpellier']
  },
  'Italy': {
    'Lazio': ['Rome'],
    'Lombardy': ['Milan'],
    'Veneto': ['Venice', 'Verona'],
    'Tuscany': ['Florence', 'Pisa'],
    'Campania': ['Naples']
  },
  'Spain': {
    'Community of Madrid': ['Madrid'],
    'Catalonia': ['Barcelona'],
    'Andalusia': ['Seville', 'Malaga', 'Granada'],
    'Valencia': ['Valencia']
  },
  'Brazil': {
    'São Paulo': ['São Paulo', 'Campinas'],
    'Rio de Janeiro': ['Rio de Janeiro'],
    'Minas Gerais': ['Belo Horizonte'],
    'Bahia': ['Salvador']
  },
  'Mexico': {
    'Mexico City': ['Mexico City'],
    'Jalisco': ['Guadalajara'],
    'Nuevo León': ['Monterrey'],
    'Quintana Roo': ['Cancún']
  },
  'India': {
    'Maharashtra': ['Mumbai', 'Pune'],
    'Delhi': ['New Delhi'],
    'Karnataka': ['Bangalore', 'Mysore'],
    'Tamil Nadu': ['Chennai'],
    'Telangana': ['Hyderabad'],
    'West Bengal': ['Kolkata']
  },
  'Thailand': {
    'Bangkok': ['Bangkok'],
    'Chiang Mai': ['Chiang Mai'],
    'Phuket': ['Phuket']
  },
  'Vietnam': {
    'Ho Chi Minh City': ['Ho Chi Minh City'],
    'Hanoi': ['Hanoi'],
    'Da Nang': ['Da Nang']
  },
  'Philippines': {
    'Metro Manila': ['Manila', 'Quezon City', 'Makati'],
    'Cebu': ['Cebu City']
  },
  'Indonesia': {
    'Jakarta': ['Jakarta'],
    'Bali': ['Denpasar', 'Ubud'],
    'East Java': ['Surabaya']
  },
  'New Zealand': {
    'Auckland': ['Auckland'],
    'Wellington': ['Wellington'],
    'Canterbury': ['Christchurch']
  },
  'South Africa': {
    'Gauteng': ['Johannesburg', 'Pretoria'],
    'Western Cape': ['Cape Town'],
    'KwaZulu-Natal': ['Durban']
  },
  'United Arab Emirates': {
    'Dubai': ['Dubai'],
    'Abu Dhabi': ['Abu Dhabi'],
    'Sharjah': ['Sharjah']
  },
  'Israel': {
    'Tel Aviv District': ['Tel Aviv'],
    'Jerusalem District': ['Jerusalem'],
    'Haifa District': ['Haifa']
  },
  'Netherlands': {
    'North Holland': ['Amsterdam'],
    'South Holland': ['Rotterdam', 'The Hague'],
    'Utrecht': ['Utrecht']
  },
  'Sweden': {
    'Stockholm': ['Stockholm'],
    'Västra Götaland': ['Gothenburg'],
    'Skåne': ['Malmö']
  },
  'Switzerland': {
    'Zurich': ['Zurich'],
    'Geneva': ['Geneva'],
    'Bern': ['Bern']
  },
  'Portugal': {
    'Lisbon': ['Lisbon'],
    'Porto': ['Porto']
  },
  'Ireland': {
    'Leinster': ['Dublin'],
    'Munster': ['Cork', 'Limerick']
  },
  'Russia': {
    'Moscow': ['Moscow'],
    'Saint Petersburg': ['Saint Petersburg']
  }
};
